const listeners = new Set();

const authEvents = {
  subscribe(callback) {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },

  emit(event) {
    listeners.forEach(cb => cb(event));
  }
};

export default authEvents;